import * as React from 'react'

export const SVG_ImageGallery = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52">
        <g fill="none" fillRule="evenodd">
            <g fill="#42B6E7" fillRule="nonzero">
                <g>
                    <g>
                        <path
                            d="M31.542 0c1.703 0 3.083 1.414 3.083 3.158v16.84c0 1.745-1.38 3.158-3.083 3.158H10.99c-1.702 0-3.083-1.413-3.083-3.157V3.158C7.906 1.414 9.286 0 10.99 0zm0 2.105H10.99c-.567 0-1.027.471-1.027 1.053v16.84c0 .582.46 1.053 1.027 1.053h.218l.049-.074 5.357-7.42c.847-1.173 2.385-1.173 3.232 0l1.14 1.583 4.02-6.674c.357-.593.883-.982 1.475-1.076l.257-.022.266.018c.584.086 1.11.464 1.472 1.048l4.094 6.615V3.158c0-.543-.4-.99-.915-1.047l-.112-.006zm-4.793 7.92l-4.81 7.997c-.15.247-.367.425-.612.496l-.188.033c-.353.034-.675-.142-.888-.44l-2.023-2.803-4.146 5.743h17.46c.53 0 .966-.41 1.022-.938L32.57 20v-.569l-5.821-9.405z"
                            transform="translate(-11 -10) translate(11 10) translate(7.906 9.25)"
                        />
                        <path
                            d="M16.813 10.688c-1.965 0-3.563-1.598-3.563-3.563s1.598-3.563 3.563-3.563c1.964 0 3.562 1.598 3.562 3.563s-1.598 3.563-3.563 3.563zm0-4.75c-.655 0-1.188.533-1.188 1.187s.533 1.188 1.188 1.188c.654 0 1.187-.534 1.187-1.188 0-.654-.533-1.188-1.188-1.188z"
                            transform="translate(-11 -10) translate(11 10) translate(7.906 9.25)"
                        />
                        <path
                            d="M2.816 14.51c.581-.003 1.065.423 1.15.98l.014.172.059 10.688c.002.494.356.902.806.98l.153.014 20.992.118c.46.002.842-.34.912-.8l.011-.158-.024-4.391c-.004-.64.512-1.16 1.151-1.164.582-.003 1.065.422 1.151.98l.014.171.024 4.39c.01 1.733-1.309 3.156-2.996 3.279l-.256.008-20.992-.117c-1.708-.01-3.106-1.344-3.25-3.028l-.012-.27-.059-10.688c-.003-.64.512-1.16 1.152-1.164z"
                            transform="translate(-11 -10) translate(11 10) translate(7.906 9.25) rotate(17 15.447 22.144)"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
